import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import EmailIcon from "components/CustomIcons/EmailIcon";
import GoogleIcon from "components/CustomIcons/GoogleIcon";

const Wrapper = styled.div`
  padding-bottom: 24px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
  border-bottom: 1px solid #a0a0a0;

  p {
    margin: 20px 0 15px;
    font-weight: bold;
    color: ${({ theme }) => theme.textColor.secondary};
  }

  a:not(:last-child) {
    display: block;
    margin-top: 5px;
    text-decoration-line: underline;
    color: ${({ theme }) => theme.textColor.secondary};
  }

  a:last-child {
    display: block;
    margin-top: 22px;
    color: #487bf2;
  }

  button {
    font-family: Roboto;
    font-weight: 500;
    font-size: 13px !important;
    line-height: 15px !important;
    color: #707173 !important;

    &:hover {
      color: #de5e56 !important;
    }
  }
`;

const Avatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 60px;
  background: #a0a0a0;
  font-weight: 600;
  line-height: 60px;
  text-align: center;
`;

const UserInfo = styled.div`
  margin: 23px 0;
`;

const Username = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: flex-end;
  color: #ffffff !important;
  margin: 0 0 3px !important;
`;

const Email = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: flex-end;
  text-decoration-line: underline;
  color: #c4c4c4;
  margin: 0 !important;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;

  a.logout-link {
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #487bf2;
  }
`;

const UserRole = styled.div`
  font-family: Roboto;
  font-weight: 500;

  .org {
    font-size: 15px;
    line-height: 18px;
    color: #e5e5e5;
    margin: 0 0 6px;
    text-align: right;
    display: block !important;
  }

  .team {
    font-size: 13px;
    line-height: 15px;
    margin: 0 0 6px;
    color: #c4c4c4;
    text-align: right;
    display: block !important;
  }

  .role {
    font-size: 13px;
    line-height: 15px;
    margin: 0 0 6px;
    color: #a0a0a0;
    text-align: right;
    display: block !important;
  }
`;

const SocialGroups = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 23px;

  svg {
    margin-left: 18px;
    color: #707173;

    &:hover {
      color: #e5e5e5;
    }
  }
`;

const UserDetail = () => {
  const { user, logout, isAuthenticated } = useAuth0();
  const profile = useSelector(state => state.profile.profile);
  
  return (
    <Wrapper>
      <FlexContainer>
        <Avatar style={profile.picture ? { backgroundImage: `url(${profile.picture})`, backgroundSize: 'contain' } : {}}>
          {profile.given_name && profile.family_name ? profile.given_name[0] + profile.family_name[0] : profile.name ? profile.name.slice(0, 2).toUpperCase() : user.name.slice(0, 2).toUpperCase()}
        </Avatar>
        <UserRole>
          <p className="org">{profile.organizations && profile.organizations[0] ? profile.organizations[0].display_name : null}</p>
          <p className="team">{profile.team ? profile.team.name : null}</p>
          <p className="role">{profile.roles && profile.roles[0] ? profile.roles[0].name : null}</p>
        </UserRole>
      </FlexContainer>
      {isAuthenticated ? 
      (<>
        <FlexContainer>
          <UserInfo>
            <Username>{profile.given_name && profile.family_name ? profile.given_name + ' ' + profile.family_name : profile.name ? profile.name : user.given_name && user.family_name ? user.given_name + ' ' + user.family_name : user.name}</Username>
            <Email>{profile.email ? profile.email : user.name}</Email>
          </UserInfo>
          <SocialGroups>
            {user.sub.split('|')[0] === "auth0" ?
              <EmailIcon /> 
              :
              user.sub.split('|')[0] === "google-oauth2" ?
                <GoogleIcon /> 
                :
                null
            }
          </SocialGroups>
        </FlexContainer>
        <FlexContainer>
          <button onClick={() => logout({ returnTo: window.location.origin })} className="logout-link" >
            Signout
          </button>
        </FlexContainer>
      </>) 
      : 
      (<>
        <Username>Guest</Username>
        <a className={"link"} href="/login">
          Login
        </a>
        <a className={"link"} href="/register">
          Register
        </a>
        <button
          onClick={() => logout()}
          className="logout-link"
        >
          Signout
        </button>
      </>)}
    </Wrapper>
  );
}

export default UserDetail;